/** Copy for the new Story path's method step (F04). */
export const METHOD_PICKER_COPY = {
  ai: {
    title: "Start with AI",
    description: "Say what it should answer. MagicBI drafts a plan.",
  },
  blank: {
    title: "Blank canvas",
    description: "Open an empty story and add charts yourself.",
  },
  file: {
    title: "From a file",
    description: "Upload a CSV and build on it.",
  },
  goal: {
    label: "What should the story answer?",
    placeholder: "Describe the question in a sentence or two.",
    helper: "MagicBI picks the data model. You can review it on the plan.",
  },
  templatesHeading: "Or start from a template",
  templatesChip: "Templates",
  templatesDetail: "These are examples, not your data.",
} as const;
